import React from 'react';

import { useIntl } from 'react-intl';

import Button, { type ButtonProps } from '@atlaskit/button/new';
import EditIcon from '@atlaskit/icon/core/edit';
import { Inline } from '@atlaskit/primitives/compiled';

import { POLLINATOR_TEST_IDS } from '../../../constants/private';

import messages from './messages';

type NewChatButtonProps = Pick<ButtonProps, 'onClick' | 'isDisabled' | 'testId'> & {
	isFullScreen?: boolean;
};

export const NewChatButton = ({
	onClick,
	isDisabled,
	isFullScreen,
}: NewChatButtonProps): React.JSX.Element => {
	const { formatMessage } = useIntl();

	// This button uses `Inline` and the icon directly to account for a centered icon + label
	// combo when `isFullScreen` is true. Simply using `shouldFitContainer` would not center the icon.
	return (
		<Button
			onClick={onClick}
			isDisabled={isDisabled}
			shouldFitContainer={isFullScreen}
			testId={POLLINATOR_TEST_IDS.NEW_CHAT_BUTTON}
			aria-label={formatMessage(messages.newChatButtonLabelFullScreen)}
		>
			<Inline space="space.100" alignBlock="center" alignInline="center">
				<EditIcon color="currentColor" label="" />
				{formatMessage(
					isFullScreen ? messages.newChatButtonLabelFullScreen : messages.newChatButtonLabel,
				)}
			</Inline>
		</Button>
	);
};
